import globalAxios from 'axios';
import { createRequestFunction, assertParamExists, DUMMY_BASE_URL, setSearchParams, toPathString } from '../common.mjs';
import { BASE_PATH } from '../base.mjs';
import { makeRemoteWithOpenapiGenerator } from '@flex-packages/remote-core';

const ThumbnailGenerateControllerApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * 
     * @summary 썸네일 조회 API
     * @param {ThumbnailGenerateControllerApiGenerateThumbnailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    generateThumbnail: ({ fileKey, size, fallbackType }, options = {}) => {
      assertParamExists("generateThumbnail", "fileKey", fileKey);
      assertParamExists("generateThumbnail", "size", size);
      assertParamExists("generateThumbnail", "fallbackType", fallbackType);
      const localVarPath = `/api/v2/thumbnail/thumbnails/{fileKey}`.replace(`{${"fileKey"}}`, encodeURIComponent(String(fileKey)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      if (size !== void 0) {
        localVarQueryParameter["size"] = size;
      }
      if (fallbackType !== void 0) {
        localVarQueryParameter["fallbackType"] = fallbackType;
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
      let headersFromBaseOptions = {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      return {
        ...localVarRequestOptions,
        identifier: "generateThumbnail",
        url: toPathString(localVarUrlObj)
      };
    }
  };
};
const ThumbnailGenerateControllerApiFp = function(configuration) {
  const localVarAxiosParamCreator = ThumbnailGenerateControllerApiAxiosParamCreator();
  return {
    /**
     * 
     * @summary 썸네일 조회 API
     * @param {ThumbnailGenerateControllerApiGenerateThumbnailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    generateThumbnail(requestParameters, options) {
      const localVarAxiosArgs = localVarAxiosParamCreator.generateThumbnail(requestParameters, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH);
    }
  };
};
const generateThumbnailRemote = makeRemoteWithOpenapiGenerator({
  requestArgsCreator: ThumbnailGenerateControllerApiAxiosParamCreator().generateThumbnail,
  requestFn: ThumbnailGenerateControllerApiFp().generateThumbnail
});

export { ThumbnailGenerateControllerApiAxiosParamCreator, ThumbnailGenerateControllerApiFp, generateThumbnailRemote };
//# sourceMappingURL=thumbnail-generate-controller-api.mjs.map
